package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class CreateMerchantResponseModel(
    val merchantId: Long = 0,
    val email: String = ""
) : BaseResponseModel()